import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import { Story } from '@/utils/storiesData';
interface EditorsPicksCarouselProps {
  stories: Story[];
}
const EditorsPicksCarousel: React.FC<EditorsPicksCarouselProps> = ({
  stories
}) => {
  const {
    resolvedTheme
  } = useTheme();
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-black';

  // Filter stories by "editor's picks" category and take only the first one
  const editorsPick = stories.find(story => story.category?.toLowerCase() === "editor's picks");
  if (!editorsPick) {
    return null;
  }
  return <section className="w-full py-16">
      <div className="w-full max-w-none px-0">
        
        
        <Link to={`/stories/${editorsPick.slug}`} className="group block w-full">
          <div className="relative w-full aspect-[4/5] md:aspect-[21/10] overflow-hidden">
            <img src={editorsPick.coverImage} alt={editorsPick.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" />
            <div className="absolute inset-0 flex items-start justify-center pt-16">
              <h3 className="text-white lg:text-6xl drop-shadow-2xl font-normal md:text-5xl px-px w-1/2 mx-auto text-2xl text-center">
                {editorsPick.title}
              </h3>
            </div>
          </div>
        </Link>
      </div>
    </section>;
};
export default EditorsPicksCarousel;